import * as yup from 'yup';

export const OrgSchema = yup.object({
  api_phone: yup.string().nullable(),
  class_name: yup.string().nullable(),
  created_tsecs: yup.number().nullable(),
  id: yup.number().defined(),
  logo_file_id: yup.number().nullable(),
  master_id: yup.number().nullable(),
  name: yup.string().defined(),
  paid: yup.boolean().defined(),
  type: yup.string().nullable(),
  updated_tsecs: yup.number().nullable(),
  uuid: yup.string().uuid().nullable(),
});

export const AllOrgsResponseSchema = yup.object({
  orgs: yup.array(OrgSchema.defined()).defined(),
});
